import React from 'react';
import { Field } from 'react-final-form';

//Components
import { campotexto } from '../campos/campos';

class FormEsqueciSenha extends React.Component {
    
    render(){        
        return (
            <>
                <Field type='text' name='email' label='E-mail' component={campotexto} />                
            </>
        )
    }
}

export default FormEsqueciSenha;